import { render, staticRenderFns } from "./handleKtcx.vue?vue&type=template&id=8684b76e&scoped=true&"
import script from "./handleKtcx.vue?vue&type=script&lang=js&"
export * from "./handleKtcx.vue?vue&type=script&lang=js&"
import style0 from "./handleKtcx.vue?vue&type=style&index=0&id=8684b76e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8684b76e",
  null
  
)

export default component.exports